<section class="auth-container">
  <!-- Offline Alert -->
  @if (!isOnline) {
    <div class="offline-banner">
      <mat-icon>wifi_off</mat-icon>
      <span>You appear to be offline. Please check your connection.</span>
    </div>
  }

  <div class="auth-content">
    <!-- Left Side - Form -->
    <div class="auth-form-section">
      <div class="auth-card">
        <!-- Logo & Header -->
        <div class="auth-header">
          <img ngSrc="../../../assets/img/brand/salesmax.png" width="2251" height="559" priority
            class="auth-logo" alt="Salesmax.ai" />
          <h1 class="auth-title">Welcome Back</h1>
          @if (!lastSuccessfulSigninNumber) {
            <p class="auth-subtitle">Enter your business phone number to receive a one-time code via SMS</p>
          }
        </div>

        <!-- Sign In Form -->
        @if (!lastSuccessfulSigninNumber) {
          <form class="auth-form" [formGroup]="signInForm">
            <div class="form-group">
              <label class="form-label">Phone Number</label>
              <ngx-intl-tel-input
                [cssClass]="'phone-input'"
                [preferredCountries]="preferredCountries"
                [enableAutoCountrySelect]="true"
                [enablePlaceholder]="true"
                [searchCountryFlag]="true"
                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                [selectFirstCountry]="false"
                [selectedCountryISO]="CountryISO.India"
                [maxLength]="15"
                [phoneValidation]="true"
                [separateDialCode]="separateDialCode"
                [numberFormat]="PhoneNumberFormat.National"
                name="sms"
                formControlName="sms"
                (keydown.enter)="onKeydown($event)"
                (keyup.enter)="signIn()">
              </ngx-intl-tel-input>
            </div>

            <button
              class="auth-button"
              type="button"
              (click)="signIn()"
              [disabled]="(busy | async) || !(signInForm.valid && signInForm.controls['sms'].valid && signInForm.controls['sms'].value !='' && signInForm.controls['sms'].value != null)">
              @if (!(busy | async)) {
                <span>Request OTP</span>
              }
              @if (busy | async) {
                <mat-spinner [diameter]="24"></mat-spinner>
              }
            </button>

            @if (errorMessage | async) {
              <div class="error-message">
                <mat-icon>error_outline</mat-icon>
                <span>{{ errorMessage | async }}</span>
              </div>
            }
          </form>
        }

        <!-- Continue with Last Number -->
        @if (lastSuccessfulSigninNumber) {
          <div class="last-signin-section">
            <button
              class="auth-button"
              type="button"
              (click)="signInWithLastsuccessful()"
              [disabled]="(busy | async)">
              @if (!(busy | async)) {
                <span>Continue with {{lastSuccessfulSigninNumber}}</span>
              }
              @if (busy | async) {
                <mat-spinner [diameter]="24"></mat-spinner>
              }
            </button>
          </div>
        }

        <!-- Footer Links -->
        <div class="auth-footer">
          @if (!lastSuccessfulSigninNumber) {
            <p class="footer-text">
              Don't have an account?
              <a routerLink='/sign-up' routerLinkActive="active" class="footer-link">Sign Up</a>
            </p>
          }
          @if (lastSuccessfulSigninNumber) {
            <p class="footer-text">
              <a (click)="clearLastSuccessfulSigninNumber()" class="footer-link">Sign in with a different number</a>
            </p>
          }
        </div>
      </div>
    </div>

    <!-- Right Side - Illustration -->
    <div class="auth-illustration-section">
      <div class="illustration-content">
        <img ngSrc="assets/img/backgrounds/sign-in.svg" width="489" height="521" alt="Sign in illustration" priority>
        <h2 class="illustration-title">Grow Your Business</h2>
        <p class="illustration-text">Manage leads, track sales, and close deals faster with Salesmax CRM</p>
      </div>
    </div>
  </div>
</section>
